import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { customFilterParams } from '@features/product-filter/product-filter.config';
import { FacetConfigResponse as FacetGroup } from '@models/api-search.models';
import { GetGroupPrefixPipe } from '@features/product-filter/pipes/get-group-prefix.pipe';
import { ReplaceKeyPipe } from '@features/product-filter/pipes/replace-key.pipe';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-facet-tags',
    templateUrl: './facet-tags.component.html',
    styleUrls: ['./facet-tags.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, SvgIconComponent, TranslateSafePipe, ReplaceKeyPipe, GetGroupPrefixPipe]
})
export class FacetTagsComponent {
    public customFilterParams = customFilterParams;

    @Output()
    public readonly resetFacets = new EventEmitter<void>();

    @Output()
    public readonly updateFacets = new EventEmitter<Params>();

    @Input()
    public readonly facetGroups?: FacetGroup[];

    @Input()
    public readonly facets?: string[][];

    public removeFacet(key: string, val: string): void {
        if (!key || !val || !this.facets?.length) {
            return;
        }

        // Filter out value to be removed
        const facetGroups = this.facets.filter(facet => facet[0] === key && facet[1] !== val);

        // Convert string[][] to Params
        // Example output: { [key]: val } || { [key]: [ val1, val2 ] }
        const group = facetGroups.reduce(
            (prev: Params, curr: string[]) => {
                prev[key].push(curr[1]);
                return prev;
            },
            { [key]: [] }
        );

        // Emit result if any
        if (group) {
            this.updateFacets.emit(group);
        }
    }

    public trackFacetFn(index: number, facet: string[]): string | number {
        return facet[1] || index;
    }
}
